<div class="content-wrapper-inner">
  <div class="page-content">
    <app-special-pricing-group-form (onAfterSave)="afterSave()"></app-special-pricing-group-form>
  </div>
</div>
